"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _ImmutableMerchandiseIdMap = _interopRequireDefault(require("self-service-api/constants/ImmutableMerchandiseIdMap"));

var _UIBadge = _interopRequireDefault(require("UIComponents/badge/UIBadge"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: 40px;\n  padding: 10px 20px;\n  width: 18.75%;\n  min-width: 175px;\n  text-align: center !important;\n  p {\n    margin: 0;\n  }\n  line-height: 14px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var TableCell = _styledComponents.default.td.withConfig({
  displayName: "ProductCatalogTableCell__TableCell",
  componentId: "sc-1c80dqe-0"
})(_templateObject());

var ProductCatalogModalTableCell = function ProductCatalogModalTableCell(_ref) {
  var merchandiseId = _ref.merchandiseId,
      featureId = _ref.featureId,
      _ref$showTooltip = _ref.showTooltip,
      showTooltip = _ref$showTooltip === void 0 ? true : _ref$showTooltip;
  var cellContent = null;
  var feature = _ImmutableMerchandiseIdMap.default[merchandiseId].features[featureId];

  if (feature) {
    if (feature.shortLimitKey) {
      var shortLimitContent = _react.default.createElement("div", null, _react.default.createElement(_Small.default, {
        style: showTooltip && feature.longLimitKey ? {
          cursor: 'help'
        } : {}
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "pricing-pages.shortLimits." + feature.shortLimitKey
      })), feature.isNew && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("br", null), _react.default.createElement(_UIBadge.default, {
        use: "new"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "pricingPage.new"
      }))));

      cellContent = feature.longLimitKey ? _react.default.createElement(_UITooltip.default, {
        use: "longform",
        placement: "left",
        disabled: !showTooltip,
        title: _react.default.createElement(_FormattedHTMLMessage.default, {
          message: "pricing-pages.fullLimits." + feature.longLimitKey
        })
      }, shortLimitContent) : shortLimitContent;
    } else {
      cellContent = _react.default.createElement(_UIIcon.default, {
        name: "success",
        size: "small"
      });
    }
  }

  return _react.default.createElement(TableCell, null, cellContent);
};

ProductCatalogModalTableCell.propTypes = {
  merchandiseId: _propTypes.default.number.isRequired,
  featureId: _propTypes.default.string.isRequired,
  showTooltip: _propTypes.default.bool
};
var _default = ProductCatalogModalTableCell;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/productCatalog/ProductCatalogTableCell.js
// module id = 693
// module chunks = 5 6